<template>
  <div class="category-selection" :style="`background-image: url(${$store.state.assetsPath}${$store.state.config.categorySelectionBackground});`">
    <div class="category-selection__categories">
      <div
        v-for="category in categories"
        class="category-selection__category touch"
        :key="category._id"
        @click="navigateToCategory(category)"
      >
        <div class="category-selection__category-inner">
          {{ category.label[language.code] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
export default {
  computed: {

    categories () {
      return this.$store.getters.navigation
    },

    language () {
      return this.$store.getters.language
    }
  },

  methods: {
    ...mapActions([
      'activateCategoryById'
    ]),

    navigateToCategory(category) {
      if (category.customRoute) {
        this.$router.push(category.customRoute)
      } else {

        const defaultChild = _.find(category.children, child => {
          return child._id === category.defaultChildId
        })

        if (defaultChild) {
          this.$router.push(`/category/${category._id}/page/${defaultChild.pageId}`)
        } else {
          this.$router.push(`/category/${category._id}/page/${category.children[0].pageId}`)
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
.category-selection {
  align-items: center;
  background-size: cover;
  display: flex;
  font-family: "Nexa";
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  .ar & {
    font-family: 'GE Dinkum';
  }  

  &__categories {
    display: flex;
    flex-wrap: wrap;
    width: 50%;
  }

  &__category {
    height: 25rem;
    padding: 2rem;
    width: 50%;
  }

  &__category-inner {
    align-items: center;
    background-color: rgba($black, 0.75);
    display: flex;
    font-size: 3rem;
    height: 100%;
    width: 100%;
    justify-content: center;
    
  }
}
</style>